import { render, staticRenderFns } from "./PublicationReportTypePicker.vue?vue&type=template&id=7907aeda&"
import script from "./PublicationReportTypePicker.vue?vue&type=script&lang=js&"
export * from "./PublicationReportTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports